import { Header, Footer, FooterRebranded } from './Components'
import Head from 'next/head'
import favicon from "src/Resources/Images/favicon.ico";
import { useEffect } from 'react';
import Script from 'next/script'
import CookieConsentModal from '../../Components/Molecules/Card/CookieConsentModal';
import { usePathname } from 'next/navigation'
import dynamic from 'next/dynamic'
import { HEADER_FOOTER_REBRANDED_KEY } from 'src/Api/Drupal';
import HeaderRebrandedNew from './Components/Header/HeaderRebrandedNew';

export default function Main({ children, title, nav, breadcrumb, description, page, marketCode, disableGrey }) {
	const pathname = usePathname();
	const urlOrigin = typeof window !== "undefined" ? window.location.origin : 'https://www.ajbell.co.uk';
	const noIndex = pathname && pathname.startsWith("/sub/");

	// Inject jquery into the window
	useEffect(() => {
		window.$ = window.jQuery = require('jquery')
	}, []);

	const script = () => {
		let script;
		if (typeof window !== "undefined") {
			if (page === 'screener') {
				if (window.innerWidth > 768) {
					script = window.usabilla_live_url = '//w.usabilla.com/f3e75a7662d3.js';
				} else {
					script = window.usabilla_live_url = '//w.usabilla.com/2e3931c99127.js';
				}
			} else {
				script = window.usabilla_live_url = '//w.usabilla.com/f95c13594611.js';
			}
		}
		return script;
	}

	const getHeader = () => {
		if (nav?.[HEADER_FOOTER_REBRANDED_KEY]) {
			return <HeaderRebrandedNew headerData={nav.header} breadcrumb={breadcrumb} topOfPageConfig={nav.topOfPageNavigation}/>
		}
		return <Header header={nav.header} topOfPageConfig={nav.topOfPageNavigation} breadcrumb={breadcrumb} />
	}

	const getFooter = () => {
		if (nav?.[HEADER_FOOTER_REBRANDED_KEY]) {
			return <FooterRebranded footerNavigation={nav.footer} />
		}
		return <Footer {...nav} />
	}

	return (
		<div>
			<Head>
				<title>{title}</title>
				<link rel="shortcut icon" href={favicon.src} type="image/x-icon" />
				{marketCode ? <link rel="canonical" href={`${urlOrigin}/market-research/${marketCode}`} /> : null}
				{noIndex ? <meta name="robots" content="noindex" /> : null}
				{description ? <meta name="description" content={description} /> : null}
			</Head>
			{getHeader()}
			<main role="main" className={disableGrey ? "" : "grey-0-gradient-vertical"}>
				{children}
			</main>
			{getFooter()}
			<Script id="usabilla feedback">
				{script()}
			</Script>
			<CookieConsentModal />
		</div>
	);
}
